var ol = require('openlayers');

ol.tilegrid.PKK5ArcGISTileGrid = function(opt_options){
    var options = opt_options || {};

    var DEFAULT_EXTENT = [
        -20037508.342787,
        -20037508.342781093,
        20037508.342781093,
        20037508.342787
    ];

    var DEFAULT_RESOLUTIONS = [
        156543.03392800014,
        78271.51696399994,
        39135.75848200009,
        19567.87924099992,
        9783.93962049996,
        4891.96981024998,
        2445.98490512499,
        1222.992452562495,
        611.4962262813797,
        305.74811314055756,
        152.87405657041106,
        76.43702828507324,
        38.21851414253662,
        19.10925707126831,
        9.554628535634155,
        4.77731426794937,
        2.388657133974685,
        1.1943285668550503,
        0.5971642835598172,
        0.29858214164761665,
        0.14929107082380833,
        0.07464553541190416,
        0.03732276770595208,
        0.01866138385297604,
        0.00933069192648802,
        0.00466534596456693,
        0.0023326729817542973,
        0.0011663364908771486,
        0.0005831682454385743,
        0.00029158412271928716,
        0.00014579206135964358
    ];

    var DEFAULT_MIN_ZOOM = 0;
    var DEFAULT_MAX_ZOOM = 30;
    var DEFAULT_TILE_SIZE = 1024;

    options['extent'] = options['extent'] || DEFAULT_EXTENT;
    options['resolutions'] = options['resolutions'] || DEFAULT_RESOLUTIONS;
    options['minZoom'] = options['minZoom'] || DEFAULT_MIN_ZOOM;
    options['maxZoom'] = options['maxZoom'] || DEFAULT_MAX_ZOOM;
    options['tileSize'] = options['tileSize'] || DEFAULT_TILE_SIZE;

    ol.tilegrid.TileGrid.call(this, options);
};
ol.inherits(ol.tilegrid.PKK5ArcGISTileGrid, ol.tilegrid.TileGrid);

module.exports = ol.tilegrid.PKK5ArcGISTileGrid;


//////////////////
// WEBPACK FOOTER
// ./src/View/PKK5ArcGISTileGrid.js
// module id = 33
// module chunks = 0